import { smallHeadingAndTextStyles } from "@insite/content-library/Components/SmallHeadingAndText";

smallHeadingAndTextStyles.heading = {
    color: "text.main",
};
